export const ROLES = {
  admin: "admin",
  gestor: "gestor",
  usuario: "usuario",
};

/** Valores iniciais do formulário Crédito mensal (OrgaDots) — percentuais em string para os inputs */
export const ORGADOTS_DEFAULT_PERCENTUAL = "92";
export const ORGADOTS_DEFAULT_PERCENTUAL_META = "1.1";

export const MOCK_PRODUTOS = [
  {
    id: 1,
    nome: "Garrafa de Alumínio",
    foto: "/assets/produtos/image-3.png",
    preco: 30,
    destaque: true,
    ultimas: false,
  },
  {
    id: 2,
    nome: "Garrafa de Plástico",
    foto: "/assets/produtos/image-2.png",
    preco: 20,
    destaque: false,
    ultimas: false,
  },
  {
    id: 3,
    nome: "Guarda Chuva Amarelo",
    foto: "/assets/produtos/image-4.png",
    preco: 50,
    destaque: true,
    ultimas: false,
  },
  {
    id: 4,
    nome: "Guarda Chuva Azul",
    foto: "/assets/produtos/image-5.png",
    preco: 50,
    destaque: true,
    ultimas: false,
  },
  {
    id: 5,
    nome: "Cadeira Azul",
    foto: "/assets/produtos/image-6.png",
    preco: 50,
    destaque: true,
    ultimas: false,
  },
  {
    id: 6,
    nome: "Caneta",
    foto: "/assets/produtos/image-7.png",
    preco: 60,
    destaque: true,
    ultimas: false,
  },
];
// const PRODURL = "https://webiste-brindes-back-845beecbe3ec.herokuapp.com"
const PRODURL = "https://orga-brindistr-back.onrender.com"
const DEV = process.env.NODE_ENV === "development";
const FORCE_PROD = false; // forçar produção
console.log("FORCE_PROD", FORCE_PROD);
console.log("DEV", DEV);
export const API_ENDPOINT = DEV
  ? FORCE_PROD
    ? PRODURL
    : "http://localhost:3001"
  : PRODURL;
console.log("API_ENDPOINT", API_ENDPOINT);
